import { useState } from 'react';
import { Dialog, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import PinchZoom from './PinchZoom';

export default function ZoomableImage({
  src,
  alt = '사진 미리보기',
  style,
  className,
  ...imageProps
}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <img
        {...imageProps}
        src={src}
        alt={alt}
        className={className}
        style={{ cursor: 'zoom-in', ...style }}
        onClick={(event) => {
          event.stopPropagation();
          setOpen(true);
        }}
      />

      <Dialog
        fullScreen
        open={open}
        onClose={() => setOpen(false)}
        PaperProps={{ sx: { backgroundColor: '#262626', overflow: 'hidden' } }}
      >
        <IconButton
          aria-label="사진 크게 보기 닫기"
          onClick={() => setOpen(false)}
          sx={{
            position: 'absolute',
            top: 'max(56px, calc(env(safe-area-inset-top, 0px) + 12px))',
            right: 12,
            zIndex: 2,
            color: '#fff',
            backgroundColor: 'rgba(0, 0, 0, 0.45)',
            '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.65)' },
          }}
        >
          <CloseIcon />
        </IconButton>

        <PinchZoom
          initialScale={1}
          minScale={1}
          maxScale={5}
          doubleClickDisabled={false}
          wrapperStyle={{ width: '100%', height: '100%' }}
          componentWrapperStyle={{ width: '100%', height: '100%' }}
          componentContentStyle={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          contents={
            <img
              src={src}
              alt={alt}
              draggable={false}
              style={{
                display: 'block',
                maxWidth: '100vw',
                maxHeight: '100vh',
                objectFit: 'contain',
                userSelect: 'none',
                WebkitUserDrag: 'none',
              }}
            />
          }
        />
      </Dialog>
    </>
  );
}
